import { render, staticRenderFns } from "./ArvoreCategoria.vue?vue&type=template&id=5a054cda&"
import script from "./ArvoreCategoria.vue?vue&type=script&lang=js&"
export * from "./ArvoreCategoria.vue?vue&type=script&lang=js&"
import style0 from "./ArvoreCategoria.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VCheckbox,VCol,VTreeview})
